<template>
    <div class="open-sans">
        <div class="w-100 site-black-bg pt-3  ">
            <div style="height: 2px; background-color: white; width: 100%; margin: 0;"></div>
        </div>
        <div class="container-fluid site-black-bg padding-top-5 pt-5 pb-5 ">


            <div class="row site-black d-flex flex-column-reverse flex-md-row">
                <div class="offset-md-1 col-md-5">
                    <div class="row site-black">
                        <div class="col-8 offset-2 col-md-5 offset-md-0 pb-5">
                            <img :src="`${$API_ASSETS}a210cf9e-4d56-4417-942e-ec8044fecd2b.png`"
                                class="img-fluid w-100 d-none d-md-inline" alt="globe" />
                        </div>
                    </div>
                    <div class="row py-3">
                        <div class="col-5 offset-1 offset-md-0 footer-item">
                            <div class="h5 py-1 pb-2 pb-md-1"> <router-link class="text-white text-uppercase"
                                    to="/shows">Shows</router-link></div>
                            <div class="h5 py-1 pb-2 pb-md-1"> <router-link class="text-uppercase"
                                    to="/classes">Classes</router-link>
                            </div>
                            <div class="h5 py-1 pb-2 pb-md-1"> <router-link class="text-uppercase"
                                    to="/company">Company</router-link>
                            </div>
                            <div class="h5 py-1 pb-2 pb-md-1"> <router-link class="text-uppercase"
                                    to="/contact">Contact</router-link>
                            </div>
                            <div class="h5 py-1 pb-2 pb-md-1"> <router-link class="text-uppercase"
                                    to="/hireus">Hire</router-link>
                            </div>
                            <!-- <div class="h5 py-1"> <router-link class="text-uppercase" to="/about">Donate</router-link>
                            </div> -->
                        </div>
                        <div class="col-5 footer-item d-flex flex-column">
                            <div class="d-flex flex-column justify-content-start flex-fill">
                                <div>609 E. Washington Ave.</div>
                                <div>Madison, WI 53703</div>
                            </div>
                            <div class=" d-flex flex-column justify-content-center flex-fill">

                                <div>608-216-5533</div>
                                <div class="text-decoration-underline">info@atlasimprov.com</div>
                            </div>
                            <div class="d-flex flex-column justify-content-center flex-fill">
                                <div>&copy;{{ currentYear }} Atlas Improv Co.</div>
                            </div>
                        </div>
                    </div>
                    <div class="row pb-5 pt-3">
                        <div class="col-md-5 col-12">
                            <div class="row justify-content-center justify-content-md-start text-center text-md-start">



                                <div class="col-6 col-md-3 text-center">
                                    <a href="https://www.facebook.com/atlasimprov" target="_blank" rel="noopener">
                                        <img src="/Facebook.svg" class="img-fluid footer-icon">
                                    </a>
                                </div>
                                <div class="col-6 col-md-3 text-center">
                                    <a href="https://www.instagram.com/atlasimprov" target="_blank" rel="noopener">
                                        <img src="/Instagram.svg" class="img-fluid footer-icon">
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-4 col-10 site-black-bg mx-auto">
                    <img :src="`${$API_ASSETS}a210cf9e-4d56-4417-942e-ec8044fecd2b.png`"
                        class="img-fluid d-block d-md-none mx-auto pb-3" alt="globe" />
                    <div class="text-white h2 text-uppercase pb-2 text-center text-md-start oswald-bold"> Join Our
                        Mailing List
                    </div>
                    <div class="text-white h6 py-2"> Be the first to hear about our special events and classes. Rest
                        assured, we only email about once a month! </div>

                    <transition name="fade">
                        <form v-if="!formSubmitted" @submit.prevent="submitEmail" class="styled-form py-2">
                            <input type="text" placeholder="Your Email" class="email-input" v-model="email" />
                            <button type="submit" class="submit-button">
                                <i class="fa-solid fa-arrow-right"></i>
                            </button>
                        </form>
                    </transition>
                    <transition name="fade">
                        <div v-if="formSubmitted" class="text-white py-2"> Thank you for signing up!</div>
                    </transition>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mailchimpConfig } from '../config/mailchimp.js';

export default {
    data() {
        return {
            email: "",
            formSubmitted: false,
            errorMessage: "",
            isSubmitting: false
        };
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        },
        mailchimpUrl() {
            return mailchimpConfig.url;
        },
        mailchimpU() {
            return mailchimpConfig.u;
        },
        mailchimpId() {
            return mailchimpConfig.id;
        }
    },
    methods: {
        submitEmail() {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(this.email)) {
                alert("Please enter a valid email address.");
                return;
            }

            this.isSubmitting = true;
            this.errorMessage = "";

            // Create JSONP callback
            const callbackName = 'mailchimpCallback' + Date.now();
            window[callbackName] = (data) => {
                this.isSubmitting = false;

                if (data.result === 'success') {
                    this.formSubmitted = true;
                    this.email = "";
                } else {
                    // Handle error - Mailchimp returns error message
                    this.errorMessage = data.msg || "Subscription failed. Please try again.";
                    alert(this.errorMessage);
                }

                // Cleanup
                delete window[callbackName];
                document.body.removeChild(script);
            };

            // Build the URL with JSONP callback
            const url = `${this.mailchimpUrl}?u=${this.mailchimpU}&id=${this.mailchimpId}&EMAIL=${encodeURIComponent(this.email)}&c=${callbackName}`;

            // Create script tag for JSONP request
            const script = document.createElement('script');
            script.src = url;
            script.onerror = () => {
                this.isSubmitting = false;
                this.errorMessage = "Network error. Please try again.";
                alert(this.errorMessage);
                delete window[callbackName];
            };

            document.body.appendChild(script);
        }
    }
}
</script>

<style>
.footer-icon {
    width: 48px;
    height: 48px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
